export const SETTINGS = 'SETTINGS';
export const COMMUNICATION = 'COMMUNICATION';
export const SOURCE_CODE = 'SOURCE_CODE';
export const ONLINE = 'ONLINE';
export const HELP = 'HELP';
export const CLOSE_ALL = 'CLOSE_ALL';
export const APP_VERSION = 'APP_VERSION';
export const TOGGLED_SIDEBAR = 'TOGGLED_SIDEBAR';



// WEBPACK FOOTER //
// ./src/store/modules/menu/mutation-types.js